import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { ComboCartColumn } from './ComboCartColumn'
import css from './ComboCart.module.scss'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { Spinner } from 'component/Spinner'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { Typo } from 'component/Typo/Typo'
import { Space } from 'component/Space'
import { i18n } from 'i18n'

export const ComboCart = observer(() => {
  const [isClient, setIsClient] = useState(false)
  const demo = useDemo()
  const { product, options } = demo

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return (
      <Space className={css.empty} center>
        <Typo size={16} secondary>
          <Spinner />
        </Typo>
      </Space>
    )
  }

  return (
    <div className={css.columns}>
      <div className={css.column}>
        <ComboCartColumn
          title={i18n('combo.Top')}
          items={comboCartStore.topItems}
          selectedItemId={comboCartStore.selectedTop}
          onSelectItem={(itemId) => comboCartStore.selectTop(itemId)}
          onRemoveItem={(itemId) => comboCartStore.removeItem(itemId)}
          emptyMessage={i18n('combo.NoTopItems')}
          options={options}
          product={product}
          showFilters={true}
          showResetButton={true}
          filterType="top"
        />
      </div>
      <ComboCartColumn
        title={i18n('combo.Bottom')}
        items={comboCartStore.bottomItems}
        selectedItemId={comboCartStore.selectedBottom}
        onSelectItem={(itemId) => comboCartStore.selectBottom(itemId)}
        onRemoveItem={(itemId) => comboCartStore.removeItem(itemId)}
        emptyMessage={i18n('combo.NoBottomItems')}
        options={options}
        product={product}
        showFilters={true}
        showResetButton={true}
        filterType="bottom"
      />
    </div>
  )
})
